import { createSelector } from '@ngrx/store';

import { ModuleItemForbiddenSubTypesCC, ModuleItemForbiddenSubTypesTIIM } from 'src/app/models/module-item-sub-type';
import { StudyType } from 'src/app/models/study-type';
import { DashboardCamelCasePipe } from 'src/app/core/pipes/dashboard-camel-case/dashboard-camel-case.pipe';
import { selectDashboardState } from '../dashboard.selectors';
import { selectSelectedStudy } from '../study/study.selectors';
import * as fromModuleItems from './module-item.reducer';

export const selectModuleItemState = createSelector(selectDashboardState, (dashboard) => dashboard?.moduleItem);

export const selectModuleItems = createSelector(selectModuleItemState, fromModuleItems.selectAll);

export const selectIsLoadingModuleItemsConfig = createSelector(
  selectModuleItemState,
  (moduleItemState) => moduleItemState?.loadingModuleItemsConfig
);

export const selectModuleItemsConfigLoaded = createSelector(
  selectModuleItemState,
  (moduleItemState) => moduleItemState?.moduleItemsConfigLoaded
);

export const selectModuleItemsConfig = createSelector(
  selectModuleItemState,
  (moduleItemState) => moduleItemState?.moduleItemsConfig
);

export const selectModuleItemsSortingOrder = createSelector(
  selectModuleItemState,
  (moduleItemState) => moduleItemState?.moduleItemsSortingOrder
);

export const selectSavedModuleItem = createSelector(
  selectModuleItemState,
  (moduleItemState) => moduleItemState?.savedModuleItem
);

export const selectSortedModuleItems = createSelector(
  selectModuleItems,
  selectModuleItemsSortingOrder,
  selectSelectedStudy,
  (moduleItems, moduleItemsSortingOrder, selectedStudy) => {
    const sortedArray = moduleItemsSortingOrder.length
      ? moduleItems.sort(
          (moduleItem1, moduleItem2) =>
            moduleItemsSortingOrder.indexOf(moduleItem1.id) - moduleItemsSortingOrder.indexOf(moduleItem2.id)
        )
      : moduleItems;

    return sortedArray.filter((item) => {
      const dashboardCamelCasePipe = new DashboardCamelCasePipe();
      const transformedResponseItem = dashboardCamelCasePipe.keysToCamelCase(item);

      switch (selectedStudy?.type) {
        case StudyType.TIIM:
          return !ModuleItemForbiddenSubTypesTIIM.some((subType) => subType === transformedResponseItem.subType);
        case StudyType.CC:
          return !ModuleItemForbiddenSubTypesCC.some((subType) => subType === transformedResponseItem.subType);
        default:
          break;
      }
    });
  }
);

export const selectIsImportingModuleItems = createSelector(
  selectModuleItemState,
  (moduleItemState) => moduleItemState?.importingModuleItems
);

export const selectModuleItemsImported = createSelector(
  selectModuleItemState,
  (moduleItemState) => moduleItemState?.moduleItemsImported
);
